"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTaskViewColumnConfigKey = void 0;
const KEY_SEGMENT_SEPARATOR = '::';
/**
 * Builds a stable, unique key for a `project–catalog–node–attribute` record used to
 * store/read its task view column configuration.
 *
 * Returns `undefined` when any required part is missing, signalling that no config
 * can be resolved yet (e.g. before query params are available).
 */
const buildTaskViewColumnConfigKey = ({ projectId, catalogId, nodeId, attributeName, }) => {
    if (!projectId || !catalogId || !nodeId || !attributeName)
        return undefined;
    return [projectId, catalogId, nodeId, attributeName].join(KEY_SEGMENT_SEPARATOR);
};
exports.buildTaskViewColumnConfigKey = buildTaskViewColumnConfigKey;
